(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    (()=>{const setup=()=>{const modal=document.getElementById('search-modal');if(!modal||modal.dataset.tcgReady)return;modal.dataset.tcgReady='true';const dialog=modal.querySelector('dialog');dialog.addEventListener('click',event=>{if(event.target===dialog)modal.closeDialog()});};setup();document.addEventListener('shopify:section:load',setup)})();
  } catch(e) { console.error(e); }
})();

})();
